import { Fragment } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, Shield } from "lucide-react";
import { UserProfile } from "@clerk/clerk-react";

function AccountSettingsModal({ show, onClose }) {
  return (
    <AnimatePresence>
      {show && (
        <Fragment>
          {/* Backdrop */}
          <motion.div
            className="fixed inset-0 cursor-pointer z-40 bg-black/40 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose} // click outside closes
          />

          {/* Modal panel */}
          <motion.div
            className="fixed text-start inset-0 z-50 max-w-5xl  mx-auto flex items-center justify-center p-4"
            initial={{ opacity: 0, scale: 0.95, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 12 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
          >
            <div
              className="w-full max-w-5xl flex justify-center mx-auto overflow-hidden "
              onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
            >
     

              {/* Body */}
              <div className="p-4 sm:p-6 ">
                <UserProfile routing="virtual" />
              </div>
            </div>
          </motion.div>
        </Fragment>
      )}
    </AnimatePresence>
  );
}

export default AccountSettingsModal;
